import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./dxfDataOutput.png"

const DXFデータ出力 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { dxfDataOutput: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="DXFデータ出力" src={img} helpURL={HELP_LINKS["DXFデータ出力"]}>
      <RadioGroup name={estimateField.dxfDataOutput.key} selectedValue={values.dxfDataOutput} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT.DXFデータ出力.あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT.DXFデータ出力.なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.dxfDataOutput} />
    </OneClickField>
  )
}

export default DXFデータ出力
